define('config/config.tracking', [

], function() {

    var tagPlan = {
        "trackingswatch": {
            "event": "trackEvent",
            "eventCategory": "Minisite_gallery_backstage_2018",
            "eventAction": "Select swatch",
            "eventLabel": "sku: {{sku}}"
        },
         "trackingshare": {
            "event": "trackEvent",
            "eventCategory": "Minisite_gallery_backstage_2018",
            "eventAction": "Share - {{socialname}}",
            "eventLabel": "{{strateid}}"
        },
        "trackingsharemmm": {
            "event": "trackEvent",
            "eventCategory": "Minisite_gallery_backstage_2018",
            "eventAction": "Share - {{socialname}}",
            "eventLabel": "Video - {{videoid}}"
        },
        "videofullscreen": {
            "event": "trackEvent",
            "eventCategory": "Minisite_gallery_backstage_2018",
            "eventAction": "Video Fullscreen",
            "eventLabel": "{{videoid}}"
        },
        "videoexitfullscreen": {
            "event": "trackEvent",
            "eventCategory": "Minisite_gallery_backstage_2018",
            "eventAction": "Video ExitFullscreen",
            "eventLabel": "{{videoid}}"
        },
        "videoplay": {
            "event": "trackEvent",
            "eventCategory": "Minisite_gallery_backstage_2018",
            "eventAction": "Video Play",
            "eventLabel": "{{videoid}}"
        },
        "videocompletion": {
            "event": "trackEvent",
            "eventCategory": "Minisite_gallery_backstage_2018",
            "eventAction": "Video Completion {{completion}}",
            "eventLabel": "{{videoid}}"
        },
        "videotimeline": {
            "event": "trackEvent",
            "eventCategory": "Minisite_gallery_backstage_2018",
            "eventAction": "Video Timeline",
            "eventLabel": "{{videoid}}"
        },
         "trackingnewsletter": {
            "event": "trackEvent",
            "eventCategory": "Minisite_gallery_backstage_2018",
            "eventAction": "Newsletter Link",
            "eventLabel": "Open newsletter form"
        },
        "trackingpage": {
            "event": "tpv",
            "pageVirtualPath": "{{pvp}}#page/{{pageid}}"
        }
    };

    return tagPlan;
});

